import { render } from "./AuthorCapital.vue?vue&type=template&id=1b96e712&scoped=true"
import script from "./AuthorCapital.vue?vue&type=script&lang=js"
export * from "./AuthorCapital.vue?vue&type=script&lang=js"

import "./AuthorCapital.vue?vue&type=style&index=0&id=1b96e712&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b96e712"]])

export default __exports__